// extracted by mini-css-extract-plugin
module.exports = {"hideInPhone":"responsive_hideInPhone__2d8M8","showInPhone":"responsive_showInPhone__3gW3D"};